import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormControlOption } from '../../interfaces/form-control-option';

@Component({
  selector: 'app-error-messages',
  templateUrl: './error-messages.component.html',
  styleUrls: ['./error-messages.component.scss'],
})
export class ErrorMessagesComponent implements OnInit {
  @Input() abstractControl: AbstractControl;
  @Input() formControlOption: FormControlOption;
  @Input() note: string;
  errorRule: boolean;

  constructor() {}

  ngOnInit() {}

  ruleError() {
    for (const rule of this.formControlOption.rules) {
      if (this.abstractControl.hasError(rule.name)) {
        return true;
      }
    }
    return false;
  }
}
